function updateGlossaryTabs() {
    // Get all glossary content sections
    const glossaryContents = document.querySelectorAll('.glossary-content');

    // Determine offset based on screen width
    const bottomOffset = window.innerWidth >= 750 ? 180 : 90;

    // Loop through each content section
    glossaryContents.forEach((content) => {
        // Get the section's position relative to viewport
        const rect = content.getBoundingClientRect();

        // Check if element is in viewport with adjusted bottom offset
        const isInViewport = rect.top < window.innerHeight && rect.bottom > bottomOffset;

        if (isInViewport) {
            // Find the h2 tag and get its id
            const h2 = content.querySelector('h2');
            if (h2 && h2.id) {
                // Reset all tabs to secondary
                document.querySelectorAll('.glossary-letters__tabs a').forEach((link) => {
                    link.classList.remove('button--primary');
                    link.classList.add('button--secondary');
                });

                // Find and activate the corresponding tab
                const correspondingTab = document.querySelector(
                    `.glossary-letters__tabs a[href="#${h2.id}"]`
                );
                if (correspondingTab) {
                    correspondingTab.classList.remove('button--secondary');
                    correspondingTab.classList.add('button--primary');
                }
            }
        }
    });
}

// Add scroll event listener
window.addEventListener('scroll', () => {
    requestAnimationFrame(updateGlossaryTabs);
});

// Initial call
updateGlossaryTabs();
